import React from "react";
import { Text } from "@radix-ui/themes";

export const WHATSAPP_TEMPLATE_QUALITY_URL = "https://developers.facebook.com/documentation/business-messaging/whatsapp/templates/template-quality";

export default function WhatsappTemplateQualityHelp({ size = "1" }) {
  return (
    <Text size={size} color="gray">
      Template quality is Meta's rating for recent template performance. GREEN means high quality, YELLOW means medium
      quality, RED means low quality, and UNKNOWN means Meta does not have enough recent data yet.{" "}
      <Text asChild size={size}>
        <a
          href={WHATSAPP_TEMPLATE_QUALITY_URL}
          target="_blank"
          rel="noreferrer"
          style={{ color: "var(--blue-11)", textDecoration: "underline" }}
        >
          Learn about template quality.
        </a>
      </Text>
    </Text>
  );
}
